import NoticeEmpty from './Empty'
import Notice from './Notice'
import { NoticeImage } from './Notice.styled'
import NoticeUnsupportedScreen from './UnsupportedScreen'

export { NoticeEmpty, NoticeUnsupportedScreen, NoticeImage }
export default Notice
